import { Field } from 'formik'
import isNil from 'lodash-es/isNil'
import React from 'react'

import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import {
  ButtonClean,
  CurrencyInput,
  InputUI,
  ProfitValue,
  useMediaQueryContext,
} from '@fourthwall/components'

import * as S from './styled'
import type { ImplicitSellingPriceProps } from './types'

export const ImplicitSellingPrice = ({
  allowExplicitType,
  sizePriceSuggestion,
  profit,
  fieldName,
  error,
  disabled = false,
  onBlur,
  onValueChange,
  onCustomizeClick,
  onLearnMoreClick,
}: ImplicitSellingPriceProps) => {
  const media = useMediaQueryContext()
  const { hasPermission } = useDashboardPermissions()

  const renderSwitchTypeButton = () => {
    if (!allowExplicitType || disabled) return null

    const label = sizePriceSuggestion ? 'Customize price' : 'Set different price per size'

    return <ButtonClean appearance="secondary" onClick={onCustomizeClick} label={label} />
  }

  const renderProfitDescription = () => {
    if (!hasPermission('contributions.profit')) return null

    const label = media.tablet ? 'Learn more' : 'How we calculate profits'

    return (
      <S.ProfitDescription>
        {!isNil(profit) && (
          <S.ProfitValueWrapper>
            <ProfitValue profit={profit} />
          </S.ProfitValueWrapper>
        )}
        {!disabled && <ButtonClean label={label} onClick={onLearnMoreClick} />}
      </S.ProfitDescription>
    )
  }

  return (
    <>
      <S.ImplicitContent>
        <S.ImplicitInput>
          <Field
            component={CurrencyInput}
            name={fieldName}
            label={!media.tablet ? 'Selling price' : undefined}
            fullWidth={!media.tablet}
            displayError={false}
            disabled={disabled}
            onValueChange={onValueChange}
            onBlur={onBlur}
          />
        </S.ImplicitInput>
        {media.tablet && renderProfitDescription()}
      </S.ImplicitContent>
      {error && <InputUI.Error>{error}</InputUI.Error>}
      <InputUI.Suggestion>
        {sizePriceSuggestion || null} {renderSwitchTypeButton()}
      </InputUI.Suggestion>
      {!media.tablet && renderProfitDescription()}
    </>
  )
}
